import React from "react";

const IdleOverlay = ({ onResume, onLogout, remainingTime }) => {
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    return (
        <>
            <style>{`
                .idle-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    backdrop-filter: blur(12px);
                    -webkit-backdrop-filter: blur(12px);
                    background: rgba(0, 0, 0, 0.45);
                    z-index: 99999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    animation: idleFadeIn 0.3s ease;
                }

                @keyframes idleFadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes idleSlideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                .idle-card {
                    background: #ffffff;
                    border-radius: 20px;
                    padding: 40px 48px;
                    text-align: center;
                    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
                    max-width: 420px;
                    width: 90%;
                    animation: idleSlideUp 0.4s ease 0.1s both;
                }

                .idle-icon-wrap {
                    width: 72px;
                    height: 72px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #00509d 0%, #182848 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 20px;
                    box-shadow: 0 8px 24px rgba(0, 80, 157, 0.3);
                }

                .idle-icon-wrap svg {
                    color: white;
                }

                .idle-title {
                    font-size: 22px;
                    font-weight: 700;
                    color: #1e293b;
                    margin-bottom: 8px;
                }

                .idle-subtitle {
                    font-size: 14px;
                    color: #64748b;
                    margin-bottom: 32px;
                    line-height: 1.5;
                }

                .idle-countdown {
                    font-weight: 700;
                    color: #ef4444;
                    font-family: monospace;
                    font-size: 16px;
                }

                .idle-btn-group {
                    display: flex;
                    gap: 12px;
                    justify-content: center;
                }

                .idle-btn {
                    padding: 12px 32px;
                    border-radius: 12px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.25s ease;
                    border: none;
                    outline: none;
                    min-width: 140px;
                }

                .idle-btn-resume {
                    background: linear-gradient(135deg, #00509d 0%, #182848 100%);
                    color: #ffffff;
                    box-shadow: 0 4px 16px rgba(0, 80, 157, 0.35);
                }

                .idle-btn-resume:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 24px rgba(0, 80, 157, 0.45);
                }

                .idle-btn-logout {
                    background: transparent;
                    color: #ef4444;
                    border: 2px solid #fecaca;
                }

                .idle-btn-logout:hover {
                    background: #fef2f2;
                    border-color: #ef4444;
                    transform: translateY(-2px);
                }
            `}</style>

            <div className="idle-overlay">
                <div className="idle-card">
                    {/* Clock/Lock icon */}
                    <div className="idle-icon-wrap">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <polyline points="12 6 12 12 16 14" />
                        </svg>
                    </div>

                    <div className="idle-title">Session Idle</div>
                    <div className="idle-subtitle">
                        You've been inactive for a while.<br />
                        You will be logged out in <span className="idle-countdown">{formatTime(remainingTime)}</span>.
                        <br />
                        Would you like to continue or log out?
                    </div>

                    <div className="idle-btn-group">
                        <button className="idle-btn idle-btn-resume" onClick={onResume}>
                            Resume
                        </button>
                        <button className="idle-btn idle-btn-logout" onClick={onLogout}>
                            Log Out
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default IdleOverlay;
